<template>
  <div v-show="show" class="container" :style="{ height: windowHeight + 'px' }">
    <!-- <van-nav-bar
      title="添加收货地址"
      left-text=""
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
    /> -->

    <van-address-edit
      :area-list="areaList"
      show-postal
      save-button-text="确定"
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      @save="addAddress"
    />
  </div>
</template>

<script>
import { areaList } from "@vant/area-data";
import api from "../../common/js/api";
export default {
  data() {
    return {
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      areaList, //省市区
      id: -1, //卡券id
      show: true,
    };
  },

  components: {},

  computed: {},

  created() {
    this.$toast({ message: "领取成功！请输入收货地址", type: "success" });
    this.getData();
  },

  mounted() {},

  methods: {
    getData() {
      this.$post(api.getByCardNo, {
        cardNo: this.$route.query.voucherCode,
      }).then((res) => {
        //status=1，表示未绑卡，=2表示已经绑卡，=3表示已经领取
        if (res.success) {
          this.id = res.data.id;
          switch (res.data.status) {
            case 1:
              this.show = false;
              this.$dialog
                .alert({
                  title: "错误",
                  message: "该卡为空卡，请联系客服",
                })
                .then(() => {
                  this.$router.replace("/");
                });
              break;
            case 2:
              this.$post(api.check, {
                id: this.$route.query.id,
                code: this.$route.query.code,
              }).then((res) => {
                console.log(res);
                if (!(res.success && res.message == "卡密正确")) {
                  this.$dialog
                    .alert({
                      title: "错误",
                      message: "请先输入密码",
                    })
                    .then(() => {
                      this.$router.replace({
                        path: "/searchResult",
                        query: { voucherCode: this.$route.query.voucherCode },
                      });
                    });
                }
              });
              break;
            case 3:
              this.$dialog
                .alert({
                  title: "错误",
                  message: "该卡被已领取",
                })
                .then(() => {
                  this.$router.replace({
                    path: "/orderDetails",
                    query: { voucherCode: this.$route.query.voucherCode },
                  });
                });
              break;
          }
        } else {
          this.show = false;
          this.$dialog
            .alert({
              title: "错误",
              message: "该卡为空卡，请联系客服",
            })
            .then(() => {
              this.$router.replace("/");
            });
        }
      });
    },
    //返回
    onClickLeft() {
      this.$router.push({
        path: "/searchResult",
        query: { voucherCode: this.$route.query.voucherCode },
      });
    },
    //添加新地址
    addAddress(content) {
      /** content内容：
       * name 收货人姓名
       * tel  收货人手机号
       * province 省份
       * city 城市
       * county   区县
       * addressDetail    详细地址
       * areaCode 地区编码，通过省市区选择获取
       * postalCode	邮政编码(自己填写的)
       * isDefault    是否为默认地址
       */
      const toast1 = this.$toast.loading({
        message: "保存中...",
        forbidClick: true,
      });
      this.$post(api.receive, {
        cardId: this.id,
        address:
          content.province +
          content.city +
          content.county +
          content.addressDetail,
        consignee: content.name,
        phone: content.tel,
        postal: content.postalCode,
      }).then((res) => {
        if (res.success) {
          toast1.clear();
          this.$router.replace({
            path: "/success",
            query: { voucherCode: this.$route.query.voucherCode },
          });
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.container {
  width: 100%;
  background-color: rgba(247, 243, 249, 1);
}
</style>